export default __webpack_public_path__ + "static/media/0035.04589812.jpg";